export default {
  web: {
    status: {
      notFoundTitle: "Seite nicht gefunden",
      notFoundDescription: "Die gesuchte Seite existiert nicht oder wurde möglicherweise verschoben.",
      supportTitle: "Support",
      supportDescription: "Wenn du Hilfe mit deinem Konto brauchst oder Fragen zu unseren Services hast, kontaktiere uns bitte per E-Mail unter support@linemate.io",
      goHome: "Zur Startseite",
      exploreTrends: "Trends entdecken",
      openTrends: "Trends öffnen",
      contactSupport: "Support kontaktieren",
    },
    download: {
      title: "Linemate herunterladen",
      subtitle: "Verfügbar für iOS, Android und im Web.",
      ios: "Für iOS herunterladen",
      android: "Für Android herunterladen",
    },
    manageSubscription: {
      title: "Abo verwalten",
      web: "Im Web verwalten",
      ios: "Auf iOS verwalten",
      android: "Auf Android verwalten",
    },
    auth: {
      loginTitle: "Bei Linemate anmelden",
      signupTitle: "Für Linemate registrieren",
      noAccount: "Noch kein Konto?",
      alreadyHaveAccount: "Du hast bereits ein Konto?",
      signUp: "Registrieren",
      setupError: "Beim Einrichten deines Kontos ist etwas schiefgelaufen. Du kannst den Vorgang möglicherweise über die Profilseite abschließen.",
      usernameTooShort: "Benutzername ist zu kurz (mind. 6 Zeichen).",
      usernameAlphaNumeric: "Der Benutzername darf nur Buchstaben und Zahlen enthalten.",
      termsPrefix: "Wenn du fortfährst, stimmst du den",
      termsOfService: "Nutzungsbedingungen",
      privacyPolicy: "Datenschutzrichtlinie von Linemate zu.",
      oddsFormatTitle: "Quotenformat-Einstellungen",
      oddsFormatDescription: "Bevor wir mit Linemate fortfahren, lege bitte fest, ob Quoten im amerikanischen oder dezimalen Format angezeigt werden sollen.",
      oddsFormat: "Quotenformat",
      passwordReset: {
        forgotTitle: "Passwort vergessen",
        resetTitle: "Passwort zurücksetzen",
        instructions: "Gib die E-Mail-Adresse ein, die mit deinem Konto verknüpft ist, und wir senden dir einen Link zum Zurücksetzen deines Passworts.",
        sentInstructions: "Du erhältst in Kürze eine E-Mail zum Zurücksetzen deines Passworts. Folge dem Link in der E-Mail, um dein Passwort zurückzusetzen.",
        sendInstructions: "Anweisungen senden",
        resendInstructions: "Anweisungen erneut senden",
        returnToLogin: "Zurück zur Anmeldung",
        signupPrompt: "Noch kein Konto? Registrieren",
        sendError: "Beim Senden der Anweisungen zum Zurücksetzen des Passworts ist etwas schiefgelaufen. Bitte versuche es später erneut.",
      },
      changePassword: {
        title: "Passwort ändern",
        subtitle: "Gib dein neues Passwort ein.",
        newPassword: "Neues Passwort",
        confirmNewPassword: "Neues Passwort bestätigen",
        passwordChanged: "Passwort geändert",
        invalidLink: "Wir konnten dein Passwort nicht zurücksetzen. Der verwendete Link ist ungültig oder abgelaufen.",
        genericError: "Wir konnten deine Anfrage nicht abschließen. Bitte versuche es später erneut oder sende den folgenden Code an unser Team, damit wir ihn prüfen können: {{code}}",
      },
    },
    inputSelection: {
      clear: "Löschen",
    },
  },
};
